/**
 * Converte qualquer formato de data/timestamp (segundos, milissegundos, string ISO UTC ou SQLite string)
 * para objeto Date válido no fuso horário local do usuário.
 */
export function parseToLocalDate(input: string | number | null | undefined): Date | null {
  if (input === null || input === undefined || input === '') return null;

  let date: Date;

  if (typeof input === 'number') {
    date = input < 10000000000 ? new Date(input * 1000) : new Date(input);
  } else if (typeof input === 'string') {
    const trimmed = input.trim();
    if (!isNaN(Number(trimmed)) && trimmed !== '') {
      const num = Number(trimmed);
      date = num < 10000000000 ? new Date(num * 1000) : new Date(num);
    } else {
      // Se for string no formato SQL ("2026-08-13 23:22:13") sem Z, anexa Z para garantir que o parse converta UTC -> Fuso Local
      const isoStr = (trimmed.includes('T') || trimmed.endsWith('Z') || trimmed.includes('+') || trimmed.includes('-'))
        ? trimmed
        : `${trimmed.replace(' ', 'T')}Z`;
      date = new Date(isoStr);
    }
  } else {
    date = new Date(input);
  }

  if (isNaN(date.getTime())) return null;
  return date;
}

export function formatSafeTime(input: string | number | null | undefined): string {
  const date = parseToLocalDate(input);
  if (!date) return '';
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export function formatSafeDate(input: string | number | null | undefined): string {
  const date = parseToLocalDate(input);
  if (!date) return '';
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatSafeDateTime(input: string | number | null | undefined): string {
  const date = parseToLocalDate(input);
  if (!date) return '—';
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
